import { DefaultCell, type IDefaultCellProps } from "./DefaultCell";

/**
 * @deprecated Use TextCell from @similarweb/pro-logic-components instead
 * @see {@link https://gitlab.int.similarweb.io/pro-frontend/pro-logic-components/-/blob/master/src/table/cells/components/core/TextCell/TextCell.tsx}
 */
export const DefaultCellHookTypeWebsite = (props: IDefaultCellProps) => (
    <DefaultCell
        {...props}
        hookType="website"
    />
);
